export default (str) => {
  const capitalised = str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  const santised = capitalised.replace(/ *\([^)]*\) */g, '');
  return santised;
}


// WEBPACK FOOTER //
// ./src/utils/toTitleCase.js